import MaintenanceBanner from './MaintenanceBanner'

export default MaintenanceBanner
